module.exports = __webpack_public_path__ + "img/ShouYao.21633f6d.svg";